export default __webpack_public_path__ + "static/media/snapchat.50d7e48a.png";